import React, { useState } from 'react';
import { ExpandMore, ExpandLess } from '../mui-icons';
import './AccordionFAQ.css';

const AccordionFAQ = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div 
      className={`faq-item ${isExpanded ? 'expanded' : ''}`}
      onClick={() => setIsExpanded(!isExpanded)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsExpanded(!isExpanded);
        }
      }}
      aria-expanded={isExpanded}
      aria-label={`${question}. ${isExpanded ? 'Clique para fechar' : 'Clique para expandir'}`}
    >
      <div className="faq-question">
        <span>{question}</span>
        {isExpanded ? (
          <ExpandLess className="faq-icon" />
        ) : (
          <ExpandMore className="faq-icon" />
        )}
      </div>
      {isExpanded && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

export default AccordionFAQ;

